"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.object.to-string.js");
var _index = _interopRequireDefault(require("@/components/Agency/index.vue"));
var _moment = _interopRequireDefault(require("moment"));
var report = _interopRequireWildcard(require("@/api/report"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _rmaNumber = require("@/api/rma-number.api");
var _imeiReceive = require("@/api/imei-receive");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Agency: _index.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listQuery: {
        page: 1,
        limit: 10
      },
      loadingSearch: false,
      tableData: [],
      total: 0,
      dateRange: [(0, _moment.default)().format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")],
      agency: {
        lv1: null,
        lv2: null,
        lv3: null,
        lv4: null
      },
      level: null,
      isAll: false,
      searchImei: ""
    };
  },
  methods: {
    changeDate: function changeDate(val) {
      this.listQuery.dateFrom = val[0];
      this.listQuery.dateTo = val[1];
    },
    doSearch: function doSearch() {
      var _this = this;
      this.loadingSearch = true;
      _imeiReceive.imeiReceiveApi.findImeis((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
        search: this.searchImei
      })).then(function (res) {
        _this.tableData = res.data.data;
        _this.total = res.data.total;
      }).finally(function () {
        _this.loadingSearch = false;
      });
    }
  }
};